var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassComposite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.8462,
    height: 180,
    fill: "url(#paint0_linear_11755_6100)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8477,
    width: 13.8462,
    height: 180,
    fill: "url(#paint1_linear_11755_6100)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6914,
    width: 13.8462,
    height: 180,
    fill: "url(#paint2_linear_11755_6100)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5391,
    width: 13.8462,
    height: 180,
    fill: "url(#paint3_linear_11755_6100)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 55.3828,
    width: 13.8462,
    height: 180,
    fill: "url(#paint4_linear_11755_6100)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 69.2305,
    width: 13.8462,
    height: 180,
    fill: "url(#paint5_linear_11755_6100)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 83.0781,
    width: 13.8462,
    height: 180,
    fill: "url(#paint6_linear_11755_6100)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 96.9219,
    width: 13.8462,
    height: 180,
    fill: "url(#paint7_linear_11755_6100)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 110.77,
    width: 13.8462,
    height: 180,
    fill: "url(#paint8_linear_11755_6100)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 124.617,
    width: 13.8462,
    height: 180,
    fill: "url(#paint9_linear_11755_6100)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 138.461,
    width: 13.8462,
    height: 180,
    fill: "url(#paint10_linear_11755_6100)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 152.309,
    width: 13.8462,
    height: 180,
    fill: "url(#paint11_linear_11755_6100)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 166.152,
    width: 13.8462,
    height: 180,
    fill: "url(#paint12_linear_11755_6100)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11755_6100",
    x1: 6.92308,
    y1: 0,
    x2: 6.92308,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11755_6100",
    x1: 20.7707,
    y1: 6.32812,
    x2: 20.7707,
    y2: 169.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11755_6100",
    x1: 34.6145,
    y1: 13.3594,
    x2: 34.6145,
    y2: 158.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11755_6100",
    x1: 48.4621,
    y1: 24.6094,
    x2: 48.4621,
    y2: 144.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11755_6100",
    x1: 62.3059,
    y1: 37.9688,
    x2: 62.3059,
    y2: 158.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11755_6100",
    x1: 76.1535,
    y1: 53.4375,
    x2: 76.1535,
    y2: 165.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11755_6100",
    x1: 90.0012,
    y1: 67.5,
    x2: 90.0012,
    y2: 176.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11755_6100",
    x1: 103.845,
    y1: 54.1406,
    x2: 103.845,
    y2: 173.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11755_6100",
    x1: 117.693,
    y1: 37.9688,
    x2: 117.693,
    y2: 158.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11755_6100",
    x1: 131.54,
    y1: 24.6094,
    x2: 131.54,
    y2: 144.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11755_6100",
    x1: 145.384,
    y1: 13.3594,
    x2: 145.384,
    y2: 158.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11755_6100",
    x1: 159.232,
    y1: 6.32812,
    x2: 159.232,
    y2: 169.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11755_6100",
    x1: 173.075,
    y1: 0,
    x2: 173.075,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6467C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BE3689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7B33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassComposite);
export default __webpack_public_path__ + "static/media/glass-composite.480232f288a9959c023d1ab148c37e2a.svg";
export { ForwardRef as ReactComponent };